<template>
<div
  id="bundle"
  v-if="id"
>
  <h2>
     Bundle '{{ name }}'
  </h2>

  <bundle-nav
    :bundleId="bundleId"
    :purchasableItemId="relationships.purchasable_item.id"
  ></bundle-nav>

  <h4>Bundle Information</h4>

  <table class="table" id="bundle-info">
    <tr>
      <td>
        Name
      </td>
      <td>
        {{ name }}
      </td>
    </tr>
    <tr>
      <td>
        Summary
      </td>
      <td>
        {{ summary }}
      </td>
    </tr>
    <tr>
      <td>
        Description
      </td>
      <td>
        {{ description }}
      </td>
    </tr>
    <tr>
      <td>
        Price
      </td>
      <td>
        <span
          v-if="isFree"
        >
          <span
            class="badge badge-sm badge-warning"
          >
            Free
          </span>
        </span>
        <span
          v-else
        >
          ${{ price }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Puzzle Count
      </td>
      <td>
        {{ puzzle_count }}
      </td>
    </tr>
    <tr>
      <td>
        Difficulty (1-100)
      </td>
      <td>
        {{ difficulty }}
      </td>
    </tr>
    <tr>
      <td>
        Inactive?
      </td>
      <td>
        {{ inactive }}
      </td>
    </tr>
    <tr>
      <td>
        Visible?
      </td>
      <td>
        {{ public }}
      </td>
    </tr>
    <tr>
      <td>
        Bundle Date
      </td>
      <td>
        {{ $root.displayDateTimeFmt(date) }}
      </td>
    </tr>
    <tr>
      <td>
        Bundle Puzzles Start At
      </td>
      <td>
        {{ start_at ? $root.displayDateTimeFmt(start_at) : 'n/a' }}
      </td>
    </tr>
    <tr>
      <td>
        Bundle Puzzles End At
      </td>
      <td>
        {{ end_at ? $root.displayDateTimeFmt(end_at) : 'n/a' }}
      </td>
    </tr>
    <tr>
      <td>
        Created At
      </td>
      <td>
        {{ $root.displayDateTimeFmt(created_at) }}
      </td>
    </tr>
    <tr>
      <td>
        Updated At
      </td>
      <td>
        {{ $root.displayDateTimeFmt(updated_at) }}
      </td>
    </tr>
  </table>

  <hr />

  <h4>Bundle Files</h4>

  <div
    v-for="item in purchasable_item.attributes.purchasable_item_attachments"
  >
    <a
      href="#"
      :class="$root.listItemClasses"
      :data-attachment-id="item.id"
      :data-attachment-mimetype="item.attributes.mimetype"
      :href="downloadUrl(item.id)"
    >
      {{ item.attributes.name }} - {{ Math.ceil(item.attributes.byte_size / 1024) }}kb
    </a>
  </div>

  <hr />

  <h4>
    Bundle Puzzles

    <button
      type="submit"
      class="btn btn-danger btn-sm"
      v-on:click.prevent="rebuildArchives"
      v-if="hasPuzzles"
    >
      Rebuild Archive
      <spinner size="small" v-if="loading" />
    </button>
  </h4>

  <pagination
    ref="puzzles"
    :resourceUrl="this.apiUrl('/puzzle_bundles/' + bundleId + '/puzzles', true)"
    :pageSize="$root.defaultPageSize"
    orderBy="puzzles.date"
  >
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :class="$root.listItemClasses"
        :to="{ name: 'puzzle', params: { puzzleId: item.id }}"
      >
        {{ item.name ? item.name : ('Puzzle #' + item.id) }}
      </router-link>
    </template>
  </pagination>

  <p>
    <button
      type="submit"
      class="btn btn-danger btn-block"
      v-on:click.prevent="deleteBundle"
    >
      Delete Bundle
    </button>
  </p>

</div>
</template>

<script>
import BundleNav from '@/components/BundleNav'

import BundleStore from '@/stores/BundleStore'
import FlashStore from '@/stores/FlashStore'

import Spinner from 'vue-simple-spinner'
import Pagination from 'sai-vue-kaminari'

export default {
  data () {
    let state = BundleStore.state
    state.loading = false
    state.hasPuzzles = false

    return state
  },

  computed: {
    isFree () {
      return this.price <= 0
    },

    orderedAttrs () {
      const attrs = [
        'name', 'summary', 'description', 'date',
        'created_at', 'updated_at', 'difficulty',
        'price', 'inactive', 'public',
        'puzzle_count'
      ]

      return attrs.map((attr) => {
        return [ attr, this[attr] ]
      })
    },

    rebuildUrl () {
      return this.apiUrl('/puzzle_bundles/' + this.bundleId + '/rebuild_archives', true)
    }
  },

  props: ['bundleId'],

  components: {
    'bundle-nav': BundleNav,
    'pagination': Pagination,
    'spinner': Spinner
  },

  created () {
    this.get()
  },

  methods: {
    downloadUrl (id) {
      return this.apiUrl('/purchasable_item_attachments/' + id + '/download', true)
    },

    get () {
      this.apiGet('/puzzle_bundles/' + this.bundleId, BundleStore, true)
    },

    deleteBundle () {
      if (confirm('This will delete the bundle, including the bundle\'s purchasable item and purchase history, and cannot be undone. Are you sure you want to delete the bundle?')) {
        this.$http.delete(
          this.apiUrl('/puzzle_bundles/' + this.bundleId, true)
        ).then((resp) => {
          this.$router.push({
            name: 'bundles'
          })

          FlashStore.result('This bundle has been deleted.')
        }, this.$root.processErrors)
      }
    },

    rebuildArchives () {
      if (confirm('This will delete the current bundle archive file and recreate the archive film from the bundle\'s puzzles. This action cannot be undone!')) {
        this.$http.post(this.rebuildUrl).then((resp) => {
          this.$router.go()

          FlashStore.result('This bundle\'s archive has been rebuilt.')
        }, this.processErrors)
      }
    },

    onPageSuccess (resp) {
      this.hasPuzzles = resp.data.data.length > 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Bundle.vue